module.exports = {
        srcSet: "/_next/static/images/BetQL_Logo_360-120-a40c4994bab41b33.png"+" 120w"+","+"/_next/static/images/BetQL_Logo_360-240-5408d4ba1312f925.png"+" 240w"+","+"/_next/static/images/BetQL_Logo_360-360-46fd1f672dcbbbdf.png"+" 360w",
        images: [{path: "/_next/static/images/BetQL_Logo_360-120-a40c4994bab41b33.png",width: 120,height: 32},{path: "/_next/static/images/BetQL_Logo_360-240-5408d4ba1312f925.png",width: 240,height: 65},{path: "/_next/static/images/BetQL_Logo_360-360-46fd1f672dcbbbdf.png",width: 360,height: 97}],
        src: "/_next/static/images/BetQL_Logo_360-360-46fd1f672dcbbbdf.png",
        toString: function(){return "/_next/static/images/BetQL_Logo_360-360-46fd1f672dcbbbdf.png"},
        
        width: 360,
        height: 97
      }